export default __webpack_public_path__ + "static/logo-ranking-33179c2686ce909cefc542cea1c94593.svg";